import type { BannerModel } from "../../../services/bannerFornecedor"

export type { BannerModel }

export type CadastroBannerFornecedorModel = {
    banners: BannerModel[]
    podeCriarBannerTelaInicial: boolean
    novoUrlBanner: string | null
    novoExibirCardapio: boolean
    novoExibirTelaInicial: boolean
}

export const CadastroBannerFornecedorInicial: CadastroBannerFornecedorModel = {
    banners: [],
    podeCriarBannerTelaInicial: false,
    novoUrlBanner: null,
    novoExibirCardapio: false,
    novoExibirTelaInicial: false,
}
